// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__r1SBS","left":"InfoRow_left__1x15k"};